// Libraries
// @ts-expect-error when we upgrade to a new version it will come with types
import {StackRouter, SwitchView, createNavigator} from '@react-navigation/core';

import {RoutesConfigType} from '../NavigationTypes';

// For web, we create a custom `createStackNavigator` function that uses a StackRouter
// with a SwitchView (no transitions).
const createStackNavigator = (routes: RoutesConfigType, config = {}) => {
  const router = StackRouter(routes, config);
  const Navigator = createNavigator(SwitchView, router, config);
  return Navigator;
};

export default createStackNavigator;
